module.exports = __webpack_public_path__ + "img/jk_action.d3d83291.png";